import React, { memo } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import SortHandler from '@v4/components/common/SortHandler'
import AdditionalText from '../../components/AdditionalText'
import Item from './components/Item'
import { useFAQ3 } from './FAQ3.hooks'

const FAQ3 = props => {
	const [
		{
			direction,
			classes,
			items,
			isMobile,
			mobileAlignment,
			mobileButtonWidth,

			mataText,
			textMetaKey,

			metaButtonText,
			buttonTextMetaKey,
			metaButtonAction,
			buttonButtonLink,
		},
	] = useFAQ3(props)

	return (
		<div className="faq-3">
			<Grid container className="faq-3-container" spacing={isMobile ? 0 : 6}>
				<SortHandler direction={direction}>
					<Grid item md={5} lg={5}>
						<AdditionalText
							className={classes.row}
							mobileAlignment={mobileAlignment}
							mobileButtonWidth={mobileButtonWidth}
							mataText={mataText}
							textMetaKey={textMetaKey}
							metaButtonText={metaButtonText}
							buttonTextMetaKey={buttonTextMetaKey}
							metaButtonAction={metaButtonAction}
							buttonButtonLink={buttonButtonLink}
						/>
					</Grid>
					<Grid item md={7} lg={7}>
						<div className="faq-3-items-container">
							{_.map(items, (key, index) => (
								<Item key={key} itemKey={key} group="items" index={index} />
							))}
						</div>
					</Grid>
				</SortHandler>
			</Grid>
		</div>
	)
}

FAQ3.propTypes = {
	metaData: PropTypes.shape({
		title: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		items: PropTypes.instanceOf(PageMetaData),
		direction: PropTypes.instanceOf(PageMetaData),
		backgroundDefault: PropTypes.instanceOf(PageMetaData),
		primary: PropTypes.instanceOf(PageMetaData),
		marginTop: PropTypes.instanceOf(PageMetaData),
		marginBottom: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(FAQ3)
